import { GraphQLError, parse } from 'graphql';

import { isEmptyOperation } from 'src/app/graph/explorerPage/operationsPane/getLintWarnings';
import { isMinLengthArray } from 'src/lib/isMinLengthArray';

export function hasGraphqlJsSyntaxErrors(sdl: string): boolean {
  if (sdl && !isEmptyOperation(sdl)) {
    try {
      parse(sdl);
    } catch (e) {
      const error = e as GraphQLError;
      return isMinLengthArray(1, error.locations);
    }
  }
  return false;
}
